module.exports = __webpack_public_path__ + "static/img/hr4.902a177.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/hr4.jpg
// module id = GS8m
// module chunks = 0